import { useState } from 'react'
import User from '@/assets/store/icon/user-photo.svg'

interface CardAccountProps {
    name: string;
    email: string;
    // Google profile photo; the placeholder is shown without one or when it fails to load
    pictureUrl?: string;
    showFamilyMember?: boolean;
}

const CardAccount = ({ name, email, pictureUrl, showFamilyMember = false }: CardAccountProps) => {
    const [failedUrl, setFailedUrl] = useState<string>()
    const photo = pictureUrl && pictureUrl !== failedUrl ? pictureUrl : undefined

    return (
        <article className="shadowCard p-3 inline-flex gap-3 justify-between items-center">
            <div className="min-w-0 inline-flex gap-3 items-center ">
                <figure className='w-[48px] h-[48px] rounded-full bg-text-grey overflow-hidden shrink-0'>
                    {photo ? (
                        // Google photo URLs can refuse requests that carry a Referer
                        <img
                            src={photo}
                            alt="my photo"
                            referrerPolicy='no-referrer'
                            onError={() => setFailedUrl(photo)}
                            className='w-full h-full object-cover'
                        />
                    ) : (
                        <img src={User} alt="my photo" className='w-auto h-auto object-cover' />
                    )}
                </figure>
                <div className="min-w-0">
                    <p className='truncate title2medium capitalize'>{name}</p>
                    <p className='truncate reg12 text-text-grey'>{email}</p>
                </div>
            </div>
            {showFamilyMember && (
                <div className="bg-text-blue-10 text-text-blue-100 px-3 py-1 rounded-[4px] text-center whitespace-nowrap">
                    <span>Family Member</span>
                </div>
            )}
        </article>
    )
}

export default CardAccount